var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#72808E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.735 8.334c.416 0 .76.311.81.714l.006.103v9.58c0 1.744-1.362 3.168-3.08 3.264l-.185.005H7.714c-1.741 0-3.164-1.364-3.26-3.083l-.005-.186v-9.58c0-.451.365-.817.816-.817.416 0 .76.311.81.714l.007.103v9.58c0 .853.651 1.553 1.484 1.628l.148.006h8.572c.852 0 1.55-.652 1.626-1.485l.006-.149v-9.58c0-.451.366-.817.817-.817zM2.816 7.312c-.45 0-.816-.366-.816-.817 0-.417.311-.76.714-.811l.102-.006 5.306-.001v-2.86c0-.416.312-.76.714-.81L8.94 2h6.122c.416 0 .76.312.81.715l.007.102-.001 2.86h5.307c.45 0 .816.367.816.818 0 .417-.311.76-.714.81l-.102.007H2.816zm11.429-3.677h-4.49v2.042h4.489V3.635z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineTrash);
export default __webpack_public_path__ + "static/media/OutlineTrash.58c5a1408cf6f4fc7ec0c5f4c43a3ea6.svg";
export { ForwardRef as ReactComponent };